import store from "../redux/store";
import { FELO_IM_URL } from "../common/const";

const options = {
  cutHash: true, // replace hash `/#/{path}` to be ''
  decoder: decodeURIComponent, // self decoder or browser's
  decodeEach: false,
  all: true, // need all value whatever it is valid or not
  encode: false, // if u need? `false | encodeURLComponent | function`
  placeholder: "", // if value is invalid, so puts the `placeholder`
};

export const UrlQueryParamsParse = (str) => {
  if (!str || !str.trim().length) return null;
  else {
    if (!~str.indexOf("?") && ~str.indexOf("=") && ~str.indexOf("&")) {
      str = str
        .split("&")
        .map((t) => t.trim())
        .filter((t) => ~t.indexOf("="))
        .map((t) => (options.decodeEach ? options.decoder(t) : t));
    } else {
      str = [str];
    }
    if (str.length) {
      return str.reduce((r, c) => {
        c = c.split("=");
        if (c.length > 2) c = [c.shift(), c.join("=")];
        if (c[0]) {
          if (c[1]) {
            r[c[0]] = +c[1] ? +c[1] : c[1];
          } else {
            r[c[0]] = options.placeholder;
          }
        }
        return r;
      }, {});
    } else {
      return null;
    }
  }
};

// json字符串转16进制
export const StringtoHex = (str) => {
  var val = "";
  for (var i = 0; i < str.length; i++) {
    if (val == "") val = str.charCodeAt(i).toString(16);
    else val += str.charCodeAt(i).toString(16);
  }
  val += "0a";
  return val;
};

export const loginClient = (loginKey) => {
  const scheme = "felo://login?token=" + loginKey;
  console.log("scheme", scheme);
  window.location.href = scheme;
};

export const CheckEmail = (email) => {
  if (!email) {
    return false;
  }
  const regx =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regx.test(String(email).toLowerCase());
};

export const tranTimestamp = (timeVal) => {
  let date = new Date(parseInt(timeVal) * 1000);
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  m = m < 10 ? "0" + m : m;
  let d = date.getDate();
  d = d < 10 ? "0" + d : d;
  let h = date.getHours();
  h = h < 10 ? "0" + h : h;
  let minute = date.getMinutes();
  let second = date.getSeconds();
  minute = minute < 10 ? "0" + minute : minute;
  second = second < 10 ? "0" + second : second;
  let dates = y + "-" + m + "-" + d + " " + h + ":" + minute;
  return dates;
};

export const OpenBrowserUrl = (url, features, isReplace = true) => {
  store.dispatch({ type: "setRedirecting", value: true });
  if (window.FeloSDK && (window.FeloSDK.isWindows || window.FeloSDK.isMac)) {
    window.FeloSDK.openBrowser(url);
  } else {
    if (isReplace && window.location.replace) {
      window.location.replace(url);
    } else {
      window.open(url, features ? features : "_self");
    }
  }
};

export const CheckSystem = {
  iOS: function () {
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    return iOS;
  },
  MAC: function () {
    var MAC =
      /macintosh|mac os x/i.test(navigator.userAgent) && !window.MSStream;
    return MAC;
  },
  Android: function () {
    var android = /Android/.test(navigator.userAgent) && !window.MSStream;
    return android;
  },
  Felo: function () {
    return /felo/i.test(navigator.userAgent.toLowerCase());
  },
};

export const getDeviceType = () => {
  const isFeloClient = CheckSystem.Felo();
  let isAndroid = "";
  let isiOS = "";
  if (window.FeloSDK) {
    isAndroid = window.FeloSDK.isAndroid;
    isiOS = window.FeloSDK.isiOS;
  } else {
    isAndroid = /android/i.test(navigator.userAgent.toLowerCase());
    isiOS = /iphone/i.test(navigator.userAgent.toLowerCase());
  }
  const DeviceType = !isFeloClient
    ? "web"
    : isAndroid || isiOS
    ? "mobile"
    : "pc";
  return DeviceType;
};

export const getTeamAvatarStr = (name) => {
  if (name) {
    return name.substr(0, 1).toUpperCase();
  }
  return "";
};

export const getRedirectUrl = () => {
  const state = store.getState();
  const redirectUrl = decodeURIComponent(state.redirectUri);
  return redirectUrl ? redirectUrl : FELO_IM_URL;
};

export const addUrlParam = (url, param) => {
  let uri = new URL(url);
  for (const key in param) {
    uri.searchParams.append(key, param[key]);
  }
  return uri.href;
};

export const getUrlParam = (paramName) => {
  return new Promise((resolve, reject) => {
    const { search, hash } = window.location;
    let urlQuery = search;
    if (!urlQuery) {
      urlQuery = hash.slice(hash.indexOf("?"), hash.length);
    }
    const urlQuertParamsStr = urlQuery.replace(/^\?/, "");
    const queryParamsData = UrlQueryParamsParse(urlQuertParamsStr);
    if (queryParamsData && queryParamsData[paramName]) {
      const urlParam = decodeURIComponent(queryParamsData[paramName]);
      resolve(urlParam);
    } else {
      resolve("");
    }
  });
};

export const openRedirectUrl = (url) => {
  if (window.location.replace) {
    window.location.replace(url);
  } else {
    window.location.href = url;
  }
};

// 统计
export const googleStatis = (eventName, param) => {
  const key = "sns_login_mark";

  switch (eventName) {
    case "sns_login": {
      localStorage.setItem(key, 1);
      window.gtag("event", eventName, param);

      break;
    }
    case "sns_success": {
      const isSnsLoginKey = JSON.parse(localStorage.getItem(key));

      if (isSnsLoginKey) {
        localStorage.setItem(key, 0);
        window.gtag("event", eventName, param);
      }

      break;
    }
    case "sns_failed": {
      const isSnsLoginKey = JSON.parse(localStorage.getItem(key));

      if (isSnsLoginKey) {
        localStorage.setItem(key, 0);
        window.gtag("event", eventName, param);
      }

      break;
    }
    case "Signup":
      window.gtag("event", eventName, param);
    default:
      break;
  }
};

export const handleResponse = (response) => {
  let contentType = response.headers.get("content-type");
  console.log("contentType", contentType);
  if (contentType.includes("application/json")) {
    return response.json();
  } else {
    return response.text();
  }
};

export const getNextPathByRegisterStatus = (status) => {
  let nextPath = "";
  switch (status) {
    case 0:
    case 2:
      nextPath = "/signin_org";
      break;
    case 3:
      nextPath = "/team_list";
      break;
    case 10:
      // 未设置密码
      nextPath = "/set_pwd";
      break;

    default:
      console.error("checkCode has other status, not set nextPath");
      break;
  }
  return nextPath;
};
